import React, { useState, useEffect, useRef } from 'react';
import { Button, Navbar, Form, InputGroup, Modal} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import MultiSelectDropdown from '../Controls/multiselectdropdown';
import { useDispatch, useSelector } from "react-redux";
import DateTimePicker from '../Controls/DateTimePicker';
import APICom from "../../utils/helpers/APICom";
import Cancelled from "../../assets/Images/CommonImages/cancel_icon.png";
import AtLocation from "../../assets/Images/CommonImages/at_location.png";
import Active from "../../assets/Images/CommonImages/pick.png";
import InActive from "../../assets/Images/CommonImages/drop.png";
import Dispatched from "../../assets/Images/CommonImages/dispatched.png";
import IRTPU from "../../assets/Images/CommonImages/irtpu.png";
import Completed from "../../assets/Images/CommonImages/trip_completed.png";
// import cancel_icon  from '../../assets/Images/CommonImages/cancel_icon.png';
// import activatetrip_icon from '../../assets/Images/CommonImages/undo_icon.png';
// import tripactions_icon from '../../assets/Images/CommonImages/redo_icon.png';
// import driveraction_icon from '../../assets/Images/CommonImages/driveraction_icon.png';
// import callback_icon from '../../assets/Images/CommonImages/callback.png'
// import vehicletracking_icon from '../../assets/Images/CommonImages/vehicletracker.png'
// import groupingaction_icon from '../../assets/Images/CommonImages/grouping_icon.png';
// import cluster_icon from '../../assets/Images/CommonImages/cluster.png';
// import history_icon from '../../assets/Images/CommonImages/history_icon.png';
import '../../assets/Styles/CancelTripCSS/CancelTripCSS.css';
import NumericControl from '../Controls/NumericControl';
import '../../assets/Styles/DispatchCSS/DispatchCSS.css';
import {Icon} from '@iconify/react';
import MenuSideBar from '../Dispatch/menuSideBar';
import { clearLoginData } from '../../features/login/loginSlice';
import EditRouteSettings from './EditRouteSettings';
import PersistStorage from '../../utils/helpers/PersistStorage';

const DispatchMainToolbar = (props = {}) => {
  
  const { FamilyData, AffiliateData, FundingSourceData, ASCSSettingData, AttributeData } = useSelector((store) => store.combinedata);
  const { isLoggedIn, loginData } = useSelector((store) => store.login);
  const [CallAgentDefaultAffiliateID , setCallAgentDefaultAffiliateID ] = useState(loginData.DefaultAffiliateID);
  const GetDefaultFamilyID = () => {
    try{
      for(var i = 0; i < AffiliateData.length; i++){
        if(CallAgentDefaultAffiliateID.toString() === "-1")
        {
          return AffiliateData[0].DTSPID.toString();
        }
        else
        {
          if(AffiliateData[i]["AffiliateID"].toString() == CallAgentDefaultAffiliateID.toString()){
            return AffiliateData[i].DTSPID.toString();
          }
        }  
      }
    }
    catch(o){}
    return "-1";
  }
  var _startDate = new Date();
  try{
    if(PersistStorage.retrieve("DispatchToolBarDate", false) != null){
      _startDate = new Date(PersistStorage.retrieve("DispatchToolBarDate", false));
    }
  }
  catch(e){_startDate = new Date(); }
  const _TodayDate = _startDate.getFullYear() + (_startDate.getMonth()< 9 ? "-0" : "-") + (_startDate.getMonth() + 1) + "-" + _startDate.getDate()
  const [HandleRouteSettingsEditPencil, setHandleRouteSettingsEditPencil] = useState([]);
  const [HandleRouteCheckDays, setHandleRouteCheckDays] = useState([]);
  const [UserAffiliateList , setUserAffiliateList ] = useState(loginData.UserAffiliateList.split(','));
  const [menuSideBarToggle, setMenuSidebar] = useState(false);
  const [SelectedRouteOrCluster, setSelectedRouteOrCluster] = useState("");
  const [showRouteDropDown, setShowRouteDropDown] = useState(false);
  const [invokeEditRouteSettings, setInvokeEditRouteSettings] = useState(false);
  const [clusterFilterMultiSelect, setrouteFilterMultiSelect] = useState({ options: [], DropdownMode: 'rS', styles: {marginLeft: "0px"}, selectedValues: [] });
  const [StatusFilterMultiSelect, SetStatusFilterMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Status Filter",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridStatusFilterSelect",className:"DispatchGridStatusFilterSelect text-nowrap",SelectAllPlaceHolder:"All Status", AllItemsSelectedPlaceHolder:"All Status",styles:{width:"auto", maxWidth:"150px", marginLeft:"0px"}});
  const [GroupingMultiSelect, SetGroupingMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Grouping Filter",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridGroupSelect",className:"DispatchGridGroupSelect text-nowrap",singleSelect:false, showCheckbox:false, SelectAllPlaceHolder:"All Group", AllItemsSelectedPlaceHolder:"All Group",styles:{width:"auto", marginLeft:"3px"}});
  const [FamilyGroupsSingleSelect, SetFamilyGroupsMultiSelect] = useState({options: [],selectedValues:[GetDefaultFamilyID()],placeholder:"Family Filter",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridFamilySelect",className:"DispatchGridFamilySelect",singleSelect:true, showCheckbox:false, TriggerSelectEventOnDataPopulate: false,styles:{width:"auto", marginLeft:"3px"}});
  const [AttributesFilterMultiSelect, SetAttributesFilterMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Attributes Filter",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridAttributesSelect",className:"DispatchGridAttributesSelect text-nowrap",SelectAllPlaceHolder:"All Attributes", AllItemsSelectedPlaceHolder:"All Attributes",styles:{width:"auto", marginLeft:"3px"}});
  const [AffiliatesFilterMultiSelect, SetAffiliatesFilterMultiSelect] = useState({options: [],selectedValues:[CallAgentDefaultAffiliateID],placeholder:"Select Affiliates",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridAffiliatesSelect",className:"DispatchGridAffiliatesSelect text-nowrap",singleSelect:true, showCheckbox:false, TriggerSelectEventOnDataPopulate: false,styles:{width:"auto", marginLeft:"3px"}});
  const [FundingSourceFilterMultiSelect, SetFundingSourceFilterMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Select FS",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridFundingSourcesSelect",className:"DispatchGridFundingSourcesSelect text-nowrap",SelectAllPlaceHolder:"All FS", AllItemsSelectedPlaceHolder:"All FS",styles:{width:"auto" , maxWidth:"150px", marginLeft:"3px"}});
  const [RequestDateOptions, SetRequestDateOptions] = useState({placeholder:"",disable:false,id:"DisptachGridRequestDate",className:"DisptachGridRequestDate",hidePlaceholder:false,styles:{width:"130px",marginLeft:"3px"},SelectAllPlaceHolder:"Select All",initialDate:_startDate});
  const [RequestTotalHoursOptions, SetRequestTotalHoursOptions] = useState(
    {
      placeholder:"",
      disable:false,
      id:"RequestTotalHoursOptions",
      className:"RequestTotalHoursOptions",
      hidePlaceholder:false,
      styles:{width:"70px",marginLeft:"3px"},
      initialValue:"24",
      maxValue:"24",
      minValue:"0"

  });
  const [updateCheckDays, setUpdateCheckDays] = useState([]);
  // const [isCheckedForRouteDropDown, setIsCheckedForRouteDropDown] = useState(false);
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [modalBodyHTML, setModalBodyHTML] = useState(null);
  const [modalFooterHTML, setModalFooterHTML] = useState(null);
  const [modalHeaderText, setModalHeaderText] = useState("");
  const [ToolboxValues, SetToolboxValues] = useState({
    Date:_TodayDate, AffiliatesList:"",FSList:"",AttrList:"", StatusList:"All Status,Undispatched,In Progress,Cancelled,No-Show,Will Call,Flagger,Hide Break/Depot Trips",Grouping:"1,2", TotalHours: 24
  });
  const dispatch = useDispatch();
  const clusterComboData = useRef([]);
  const clusterComboDataBackup = useRef([]);
  const mainGridRowData = useRef([]);
  const menuTracker = useRef(false);
  const navBarRef = useRef(null);
  const affiliateRef = useRef(0);
  const transitTypeRef = useRef([]);
  const APICallRef = useRef(false);
  const editRouteSetDataRef = useRef([]);
  const affChangeFlagRef = useRef("");
  const mapBtnRef = useRef(null);
  const showCompletedCheckRef = useRef(false);
  const handleLogout = () => {
    // Perform logout actions here
    // For example: clear authentication tokens, redirect, etc.
    if(isLoggedIn)
    {
      dispatch(clearLoginData());
    }

  };

  const handleInvokeSidebarToggle = (e) =>{
    try{
      setMenuSidebar(prevCheck => !prevCheck);
      menuTracker.current = true;
      props.setSideBarStatus(true);
      handleOpenSidebar();
    }
    catch(err){console.log(err);}
  };

  const handleOpenSidebar = ()=>{
    try{
      if(menuTracker.current)
      {
        // console.log("open");
        navBarRef.current.classList.add('navBarStyle');
        let gridContainer = document.getElementById(props.options.GridName+"_container");
        let mapContainer = document.getElementById(props.options.GridName +'_mapContainer');
        let clusterContainer = document.getElementById("clusterTableGrid_container");
        if(document.getElementById(props.options.GridName+'_mapViewBtn').textContent.toUpperCase() === "MAP")
        {
          gridContainer.classList.add('gridClosedMapStyle');
        }
        else
        {
          gridContainer.classList.add('gridOpenMapStyle');
          mapContainer.classList.add('mapOpenStyle');
          clusterContainer.classList.add('mapOpenStyle');
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleInvokeCancelTrip = () => {
    props.initiateCancel(true);
  }
  const handleInvokeActivateTrip = () => {
    props.initiateActivate(true);
  }
  const handleInvokeCallAgent = () => {
    try{
      window.open('/CallAgent', 'com_domain_callAgentScreen');
    }
    catch(err){console.log(err);}
  };

  const handleInvokeEditTripCallAgent = () => {
    try{
      if(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) !== 2)
      {
        const rowSelectedCheck = PersistStorage.retrieve("rowDataCallAgent", true);
        if(rowSelectedCheck && rowSelectedCheck.length > 0)
        {
          if(rowSelectedCheck.length === 1)
          {
            setModalHeaderText("Call Agent Action");
            setModalBodyHTML(<b>{"Would you like to cancel the current selected trip and book a new trip?"}</b>);
            setModalFooterHTML(
              <>
                <Button variant='dark' className="border-0" onClick={()=>{setShowDynamicModal(false); window.open('/CallAgent?TripSelected=true', 'com_domain_callAgentScreen');}}>
                  Yes
                </Button>
                <Button variant='secondary' className="border-0" onClick={()=>{setShowDynamicModal(false); window.open('/CallAgent', 'com_domain_callAgentScreen');}}>
                  No
                </Button>
              </>
            );
            setShowDynamicModal(true);
            // window.open('/CallAgent?TripSelected=true', 'com_domain_callAgentScreen');
          }
          else
          {
            //Multiple Trips selected
            setModalHeaderText("Multiple Trips Selected");
            setModalBodyHTML(<b>{"Please select a single trip to edit."}</b>);
            setModalFooterHTML(
              <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                OK
              </Button>
            );
            setShowDynamicModal(true);
          }
        }
        else
        {
          //No trip selected
          setModalHeaderText("No Trip Selected");
          setModalBodyHTML(<b>{"Please select a trip to edit."}</b>);
          setModalFooterHTML(
            <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
              OK
            </Button>
          );
          setShowDynamicModal(true);
        }
      }
    }
    catch(err){console.log(err);}
  };
  const handleInvokeTripActions = () => {
    props.setShowTripActionsDialog(true);
  }

  const handleInvokeDriverActions = () => {
    props.setDriverActionsDialog(true);
  }
  const handleInvokeGroupingActions = () => {
    props.setShowGroupingActionDialog(true);
  }

  const handleInvokeVehicleTracking = () => {
    props.initiateVehicleTracking(true);
  }

  const handleInvokeAgileDispatch = () => {
    props.initiateAgileDispatch(true);
  }
  const handleInvokeUpdateCallback = () => {
    props.initiateUpdateCallback(true);
  }
  const handleBrokerActions = () => {
    props.setBrokerActionsDialog(true);
  }

  const handleTripInformation = () => {
    props.setTripDetailsDialog(true);
  }
  const handleMTDiagnostic = () => {
    props.setMTDiagnosticDialog(true);
  }

  const handleInvokeClusteringActions = () => {
    props.setShowClusterDialog(true);
  }

  const handleInvokeBuildManifestActions = () => {
    props.setManifestBuildDialog(true);
  }

  const handleInvokeShowRoutes = ()=>{
    props.setShowRoutesDialog(true);
  };

  const handleInvokeRBSProcessActions = () => {
    props.setRBSProcessDialog(true);
  }
  const handleStandingRouteActions = () => {
    props.setStandingRouteDialog(true);
  }

  const handleRouteSettingEdit = (e)=>{
    try{
      editRouteSetDataRef.current = [];
      let data = clusterComboData.current.find((item)=>item.vVirtualRoute === e.target.dataset.virtual);
      editRouteSetDataRef.current = data;
      setInvokeEditRouteSettings(true);
    }
    catch(err){console.log(err);}
  };
  const addHandleRouteSettingsEditPencil = (element) => {
    if (element && !HandleRouteSettingsEditPencil.includes(element)) {
      setHandleRouteSettingsEditPencil(prevRefs => [...prevRefs, element]);
    }
  };
  useEffect(() => {
    // Now you can access each element via elementRefs array
    HandleRouteSettingsEditPencil.forEach(ref => {
      //console.log(ref); // This will log each element
      ref.addEventListener('click', handleRouteSettingEdit);
    });
    // Cleanup: remove event listeners
    return () => {
      HandleRouteSettingsEditPencil.forEach(ref => {
        ref.removeEventListener('click', handleRouteSettingEdit);
      });
    };
  }, [HandleRouteSettingsEditPencil]);

  const handleSaveSelectionForDateAPI = async(routeSelected, routeCheckFlag)=>{
    try{
      let routeCheckFlagCheck = routeCheckFlag ? 1:0;
      let checkItem = updateCheckDays.find((item)=>Object.keys(item)[0] === routeSelected);
      let index = updateCheckDays.findIndex(item=>item.hasOwnProperty(routeSelected));
      if(Object.values(checkItem)[0] !== routeCheckFlagCheck){
        updateCheckDays[index][routeSelected] = routeCheckFlagCheck;
        setUpdateCheckDays(updateCheckDays);
      }
      let data = clusterComboData.current.find((item)=>item.vVirtualRoute === routeSelected);
      let date = data.dtRouteStartTime.split("T")[0];
      let selectedRoutes = "";
      let unSelectedRoutes = "";
      let selectedDepots = "";
      let selectedVeh = "";
      for(let k = 0; k < updateCheckDays.length; k++)
      {
        if(Object.values(updateCheckDays[k])[0])
        {
          selectedRoutes += Object.keys(updateCheckDays[k])[0] +",";
          let tempData = clusterComboData.current.find((item)=>item.vVirtualRoute === Object.keys(updateCheckDays[k])[0]);
          selectedDepots += String(tempData.iDepot) +",";
          selectedVeh += String(tempData.iVehicleID) + ",";
        }
        else
        {
          unSelectedRoutes += "'"+ Object.keys(updateCheckDays[k])[0] +"',";
        }

      }
      // console.log(data);
      let params = {
        "vSettingName": data.vSettingName,
        "dtSelectedDate": date,
        "iSettingID": parseInt(data.iSettingID),
        "selectedRoutes": selectedRoutes,
        "selectedVehicle": selectedVeh,
        "selectedDepots": selectedDepots,
        "unSelectedRoutes": unSelectedRoutes,
        "currentlySelectedRoute": routeSelected,
        "isDay": routeCheckFlag
      }
      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/SaveSelectedDaysForDate", "post", { "Content-Type": "application/json" }, params,  null);
      let result = response.data;
      // console.log(result);
      if(result !== null && result.length > 0)
      {
        if(result[0].Result.toUpperCase() !== "FAILED")
        {
          APICallRef.current = false;
        }
      }
    }
    catch(err){console.log(err);}
  };

  const handleDayCheckRef = (e)=>{
    try{
      e.stopPropagation();
      // setIsCheckedForRouteDropDown(e.target.checked);
      setUpdateCheckDays(prevState=>{
        let newState = prevState;//{...prevState};
        let index = prevState.findIndex(item=>item.hasOwnProperty(e.target.dataset.virtual));
        newState[index][e.target.dataset.virtual] = e.target.checked? 1:0;
        return newState;
      });
      handleSaveSelectionForDateAPI(e.target.dataset.virtual, e.target.checked);
      

      // let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/SaveSelectedDaysForDate", "post", { "Content-Type": "application/json" }, params,  null);
      // let result = response.data;
      // if(result !== null && result.length > 0)
      // {
      //   // console.log(result);
      //   props.setDetailDataFunc([]);
      //   props.setDetailDataFunc(result);
      // }
    }
    catch(err){console.log(err);}
  };

  const handleCheckForDay = (e)=>{
    try{
      if (e && !HandleRouteCheckDays.includes(e)) {
        setHandleRouteCheckDays(prevRefs => [...prevRefs, e]);
      }
    }
    catch(err){console.log(err);}
  };

  useEffect(() => {
    // Now you can access each element via elementRefs array
    HandleRouteCheckDays.forEach(ref => {
      //console.log(ref); // This will log each element
      ref.addEventListener('click', handleDayCheckRef);
    });
    // Cleanup: remove event listeners
    return () => {
      HandleRouteCheckDays.forEach(ref => {
        ref.removeEventListener('click', handleDayCheckRef);
      });
      // console.log(APICallRef.current);
      // if(!APICallRef.current && clusterComboData.current.length > 0)
      // {
      //   console.log("got to after event listener");
      //   showDropDownOptions({Given:"AFFILIATE", Value:parseInt(clusterComboData.current[0].iAffiliateID)});
      //   APICallRef.current = true;
      // }
    };
  }, [HandleRouteCheckDays]);

  const showDropDownOptions = async(data)=>{
    try{
      // if(document.getElementById(props.options.GridName+'_mapViewBtn').textContent.toUpperCase() === "BACK")
      // {
        
        // setShowRouteDropDown(false); AffiliateData.find(item=>String(item.DTSPID)===data);
        const set = new Set();
        let groupOptions = [];
        let checkDaysArr = [];
        let tempDict = {};
        let status = null;
        let affID = "";//(ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0]:ToolboxValues.AffiliatesList);
        let dataObj = null;
        if(data.Given === "COMPANY")
        {
          dataObj = AffiliateData.find(item=>String(item.DTSPID)===data.Value);
          affID = dataObj.AffiliateID;
        }
        else if(data.Given === "AFFILIATE")
        {
          affID = data.Value;
        }
        affiliateRef.current = affID;
        let date = ToolboxValues.Date;
        // console.log("repeated",affID,data); 
        if(affID !== "")
        {
          let filteredData= AffiliateData.filter(item => String(item.AffiliateID) === affID);
          let iTransTypeValue = '0';
          if (filteredData.length > 0 && filteredData[0].iTransType !== undefined && filteredData[0].iTransType !== null) {
            iTransTypeValue = String(filteredData[0].iTransType);
          }
          let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetAllTodaysRoutes?selected_date=" + date + "&affiliate_id=" + affID + "&iTransType=" + iTransTypeValue,  "get", { "Content-Type": "application/json" }, null, null);
          // console.log("for aff ", affID, response);
          if(response.data)
          {
            clusterComboData.current = response.data; 
            clusterComboDataBackup.current = response.data;
            // console.log(clusterComboData.current);
          }
          else
          {
            setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, options: groupOptions, selectedValues: "" });
            setShowRouteDropDown(true);
            clusterComboData.current = []; 
            clusterComboDataBackup.current = [];
          }
          // console.log("cluster data", clusterComboData.current);
          if(clusterComboData.current !== undefined && clusterComboData.current.length !== 0) {
            clusterComboData.current?.forEach((data)=>{
              let checkforDays = (String(data.SelectedForTheDay) === "false" || String(data.SelectedForTheDay) === "0"? 0:1);
              tempDict = {};
              tempDict[data.vVirtualRoute] = checkforDays;
              checkDaysArr.push(tempDict);
            });
            setUpdateCheckDays(checkDaysArr);
            clusterComboData.current?.forEach((data, index) => {
              if (data.vVirtualRoute && !set.has(data.vVirtualRoute)) {
                set.add(data.vVirtualRoute);
                // if(data?.RouteStatus.toUpperCase().includes("CALLOUT") || data?.RouteStatus.toUpperCase().includes("LOCATION"))
                // {
                //   status = AtLocation;
                // }
                // else if(data?.RouteStatus.toUpperCase().includes("CANCEL"))
                // {
                //   status = Cancelled;
                // }
                if(data?.RouteStatus.toUpperCase().includes("ACCEPTED") 
                  || data?.RouteStatus.toUpperCase().includes("ASSIGN") 
                  || data?.RouteStatus.toUpperCase().includes("OFFERED") || data?.RouteStatus.toUpperCase().includes("SCHEDULE"))
                {
                  status = Dispatched;
                }
                else if(data?.RouteStatus.toUpperCase().includes("DROP") || data?.RouteStatus.toUpperCase().includes("TREATED")
                  || data?.RouteStatus.toUpperCase().includes("COMPLETE"))
                {
                  status = Completed;
                }
                else if(data?.RouteStatus.toUpperCase().includes("PICKED") || data?.RouteStatus.toUpperCase().includes("IRTPU") 
                  || data?.RouteStatus.toUpperCase().includes("PROGRESS"))
                {
                  status = IRTPU;
                }
                else if(data?.RouteStatus.toUpperCase().includes("STARTED"))
                {
                  if(data?.RouteStatus.toUpperCase().includes("NOT"))
                  {
                    status = InActive;
                  }
                  else
                  {
                    status = Active;
                  }
                }
                groupOptions.push({"label": 
                <table className="w-auto" style={{height:"50px !important"}}>
                  <tbody>
                    <tr className="text-center text-nowrap">
                      <td style={{maxWidth:"60px", minWidth: "59px" , width:"60px !important", fontSize:"x-small"}} title={data.vVirtualRoute} className="p-0 m-0 user-select-none overflow-hidden">
                        {data.vVirtualRoute}
                      </td>
                      <td style={{maxWidth:"60px", minWidth: "59px" , width:"60px !important", fontSize:"x-small"}} title={data.vSettingName} className="p-0 m-0 px-1 mx-1 user-select-none overflow-hidden">
                        {data.vSettingName}
                      </td>
                      <td style={{maxWidth:"30px", minWidth: "29px" , width:"30px", fontSize:"x-small"}} className="p-0 m-0 px-1 mx-1 user-select-none">
                        {data.iTotalNoOfTrip}
                      </td>
                      <td style={{maxWidth:"40px", minWidth: "39px" , width:"40px", fontSize:"x-small"}} title={data.iTotalDistMile} className="p-0 m-0 px-1 mx-1 user-select-none">
                        {data.iTotalDistMile === "" || data.iTotalDistMile === null? "0":data.iTotalDistMile}
                      </td>
                      <td style={{maxWidth:"40px", minWidth: "39px" , width:"40px", fontSize:"x-small"}} title={data.vName} className="p-0 px-1 text-start m-0 mx-1 user-select-none overflow-hidden">
                        {data.vName === "" || data.vName === null? "N/A":data.vName}
                      </td>
                      <td style={{maxWidth:"50px" ,width:"50px", fontSize:"small"}} className="p-0 m-0 mx-1 user-select-none">
                        <input type='checkbox' className={"float-start mx-1 mt-1"} style={{cursor:"pointer"}} onChange={handleDayCheckRef} checked={checkDaysArr[index][data.vVirtualRoute]} ref={handleCheckForDay} title={"Check for Day"} data-virtual={data.vVirtualRoute} disabled = {data.iSettingID == -1? true:false}/>
                        {((data.iSettingID == -1) || (data?.vVirtualRoute.charAt(data?.vVirtualRoute.length - 1) == 'C'))? (
                          <p className='m-0' 
                             style={{ cursor: "default", opacity: 0.5 }} 
                             title={"Not Allowed"} 
                             data-virtual={data.vVirtualRoute}>
                              ✎
                          </p>
                      ) : (
                          <p className='m-0' 
                             style={{ cursor: "pointer" }} 
                             title={"Edit Route Setting"} 
                             data-virtual={data.vVirtualRoute} 
                             ref={addHandleRouteSettingsEditPencil}
                             //</td>onClick={yourOnClickFunction}
                             >
                              ✎
                          </p>
                      )}
                      </td>
                      <td style={{maxWidth:"50px" ,width:"50px", fontSize:"x-small"}} className="p-0 m-0 mx-1 px-3 user-select-none">
                        <img src={status} style={{width:"16px", height:"16px"}} className='mx-1' title={data.RouteStatus}/>
                      </td>
                    </tr>
                  </tbody>
                </table>, 
                "value": data.vVirtualRoute})
              }
            });
          }
          if(groupOptions.length > 0)
          {
            groupOptions = [{ "label":
            <table className="w-auto" style={{height:"50px !important"}}>
              <thead>
                <tr className="text-center text-nowrap">
                  <th style={{width:"60px", fontSize:"small"}} className="px-2 user-select-none">
                    {"Route"}
                  </th>
                  <th style={{width:"60px", fontSize:"small"}} className="px-2 user-select-none">
                    {"sName"}
                  </th>
                  <th style={{width:"50px", fontSize:"small"}} className="px-1 user-select-none">
                    {"Trips"}
                  </th>
                  <th style={{width:"50px", fontSize:"small"}} className="px-1 user-select-none">
                    {"Dist"}
                  </th>
                  <th style={{width:"50px", fontSize:"small"}} className="px-1 user-select-none">
                    {"Type"}
                  </th>
                  <th style={{width:"50px", fontSize:"small"}} className="px-1 user-select-none">
                    {"Edit"}
                  </th>
                  <th style={{width:"50px", fontSize:"small"}} className="px-1 user-select-none">
                    {"Status"}
                  </th>
                </tr>
              </thead>
            </table> , "value": "info" }].concat(groupOptions);
          }
          setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, options: groupOptions, selectedValues: groupOptions.length > 0 ? groupOptions[0].value :"" });
          setShowRouteDropDown(true);
        }     
      // }
    }
    catch(err){console.log(err);}
    
  };

  const handleClusterTripsLoad = async(val)=>{
    try{
      let actualData = clusterComboDataBackup.current.find((item)=>item.vVirtualRoute === val);
      let affID = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0]:ToolboxValues.AffiliatesList);
      let date = ToolboxValues.Date;
      // let settingID = actualData.iSettingID;
      let params = {};
      props.setSelectedRoute(actualData.vManifestNumber);
      props.setDropDownRoute(val);
      if (actualData.vManifestNumber === '' || actualData.vManifestNumber === null || actualData.vManifestNumber === undefined){
        params = {
          "vManifestNumber": actualData.vVirtualRoute,
          "dtSelectedDate": date,
          "vehicleId": -1,
          "bIncludePerformed": showCompletedCheckRef.current,
          "vAffIDs": String(affID),
          "confirmationNo": "",
          "iDepotID" : actualData.iDepot,
          "iFetchMode": 2,
          "iSettingID": String(actualData.iSettingID)
        }

      }
      else if (actualData.vManifestNumber != '')
      {
        params = {
          "vManifestNumber": actualData.vManifestNumber,
          "dtSelectedDate": date,
          "vehicleId": -1,
          "bIncludePerformed": showCompletedCheckRef.current,
          "vAffIDs": String(affID),
          "confirmationNo": "",
          "iFetchMode": 0,
          "GridName": "SelectedGridRouteSRQARQPRQ_NewC",
          "iUserID": loginData.iUserID
        }
      }

      let response = await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Routing/GetRouteStopView", "post", { "Content-Type": "application/json" }, params,  null);
      let result = response.data;
      if(result !== null && result.data && result.data.length > 0)
      {
        // console.log(result);
        props.setDetailDataFunc([]);
        props.setDetailDataFunc(result.data);
        props.setSettings(result.setting);
      }
      else
      {
        props.setDetailDataFunc([]);
      }

    }
    catch(err){console.log(err);}
  };

  const handleMapView = () => {
    try{
      if(mapBtnRef.current.textContent.toUpperCase() === "MAP")
      {
        mapBtnRef.current.textContent = "Back";
        mapBtnRef.current.title = "Grid View";
        let gridContainer = document.getElementById(props.options.GridName+"_container");
        let clusterContainer = document.getElementById("clusterTableGrid_container");
        let mapContainer = document.getElementById(props.options.GridName +'_mapContainer');
        gridContainer.className = "col-6 d-inline-flex float-start";
        // let affData = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0]:ToolboxValues.AffiliatesList);
        // showDropDownOptions({Given:"AFFILIATE",Value:affData});
        props.handleMapMode(true);
        if(document.getElementById("sidebar") && document.getElementById("sidebar").classList.contains("open"))
        {
          if(gridContainer.classList.contains('gridOpenMapStyle')){gridContainer.classList.add('gridOpenMapStyle')};
          if(mapContainer)
          {
            if(mapContainer.classList.contains('mapOpenStyle')) {props.options.mapClass+='mapOpenStyle';}
          }
          if(clusterContainer)
          {
            if(clusterContainer.classList.contains('mapOpenStyle')){clusterContainer.classList.add('mapOpenStyle');}
          }
        }

      }
      else if(mapBtnRef.current.textContent.toUpperCase() === "BACK")
      {
        mapBtnRef.current.textContent = "Map";
        mapBtnRef.current.title = "Map View";
        let gridContainer = document.getElementById(props.options.GridName+"_container");
        gridContainer.className = "col";
        props.handleMapMode(false);
        // setShowRouteDropDown(false);
        if(document.getElementById("sidebar") && document.getElementById("sidebar").classList.contains("open"))
        {
          // console.log("went here on back" );
          gridContainer.classList.contains('gridClosedMapStyle')?console.log("nothing"):gridContainer.classList.add('gridClosedMapStyle');
        }
      }
    }
    catch(err){console.log(err);}
  }
  const RouteSelectCallback = (_val) => {
    // console.log(mapBtnRef);
    if(mapBtnRef.current.textContent === "Map")
    {
      mapBtnRef.current.click();
    }

    // console.log(_val);
    if(_val !== "info")
    {
      handleClusterTripsLoad(_val);
    }
   
    if (_val !== "") {
      setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(_val) } });
    }
    else
    {
      setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: [] } });
    }
  }
  const GetClusterSelectObjectBy = (_vVal) => {
    try{
      let groupOptions = [];
      for (let ii = 0; ii < clusterComboData.current.length; ii++) {
          if (_vVal.includes(clusterComboData.current[ii].vVirtualRoute)) {
            groupOptions.push({ 
                "label": clusterComboData.current[ii].vVirtualRoute, 
                "value": clusterComboData.current[ii].vVirtualRoute 
            });
            //groupOptions.push({ "label": clusterComboData.current[ii].vVirtualRoute, "value": (clusterComboData.current[ii].vManifestNumber+"_"+clusterComboData.current[ii].vVirtualRoute) });
            break;
          }
      }
      return groupOptions;
    }
    catch(err){console.log(err);}
  }
  const handleSetGroupingHeader = (e)=>{
    props.setGroupingFilter(e.target.value);
  }

  const handleUserInput = (e)=>{
    let elements = document.getElementsByClassName('sidebarOptionClass');
    for(let i = 0; i < elements.length; i++)
    {
      if(elements[i].children[0].textContent.toLowerCase().includes("driver"))
      {
        if(e.target.value.toLowerCase().includes("admin"))
        {
          elements[i].style.display = "block";
        }
        else if(e.target.value.toLowerCase().includes("color"))
        {
          elements[i].style.display = "block";
        }
        else if(elements[i].children[0].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
        {
          elements[i].style.display = "block";
        }
        else
        {
          elements[i].style.display = "none";
        }
      }
      else
      {
        if(!elements[i].children[0].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
        {
          elements[i].style.display = "none";
        }
        else
        {
          elements[i].style.display = "block";
        }
      }
      
    }
  };

  const handleInvokeTripHistoryActions = () => {
    props.setTripHistoryDialog(true);
  };

  const handleRouteDropDownClick = (e)=>{
    try{
      // console.log(e.target.tagName, e.target.className);
      let tagList = ["svg", "path"]; 
      let userSelectedObjClass = (e.target.tagName !== "svg" && e.target.tagName !== "path"? e.target.className: "");
      userSelectedObjClass = userSelectedObjClass.replace(/\s/g, '');
      // console.log(affChangeFlagRef.current, props.selectedAffiliates);
      let classList = ["css-1fdsijx-ValueContainer", "css-qbdosj-Input", "css-15lsz6c-indicatorContainer"];
      if(affChangeFlagRef.current !== String(props.selectedAffiliates) && (classList.includes(userSelectedObjClass) || tagList.includes(e.target.tagName)))
      {
        let affSelection = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0]:ToolboxValues.AffiliatesList);
        clusterComboData.current = [];
        showDropDownOptions({Given:"AFFILIATE", Value:affSelection}); 
      }
    }
    catch(err){console.log(err);}
  };

  const handleCheckCompleted = (e)=>{ 
    try{
      if(e.target.checked)
      {
        props.handleClusterReload(mainGridRowData.current, true);
        props.setCheckCompletedTrips(true);
        showCompletedCheckRef.current = true;
      }
      else
      {
        props.handleClusterReload(mainGridRowData.current, false);
        props.setCheckCompletedTrips(false); 
        showCompletedCheckRef.current = false;
      }
    }
    catch(err){console.log(err);}
  };

  useEffect(() => {
    mainGridRowData.current = props.mainSelectedRow;
  },[props.mainSelectedRow]);

  useEffect(() => {
    let initialFamilyGroupSelected = [];
    SetStatusFilterMultiSelect({ ...StatusFilterMultiSelect, ...{options: [{"name":"Undispatched", "id":"Undispatched"}, {"name":"In Progress", "id":"In Progress"}, {"name":"Cancelled", "id":"Cancelled"}, {"name":"No-Show", "id":"No-Show"}, {"name":"Will Call", "id":"Will Call"}, {"name":"Flagger", "id":"Flagger"}, {"name":"Hide Break/Depot Trips", "id":"Hide Break/Depot Trips"}]}});
    SetGroupingMultiSelect({ ...GroupingMultiSelect, ...{options: [{"name":"Grouped", "id":"1"}, {"name":"UnGrouped", "id":"2"}]}});
    SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: []}});
    let allowedaffiliates = loginData.UserAffiliateList.split(',');
    let allowedFamilies = []
    if(allowedaffiliates.length>0){
      try{
        for(var i = 0; i < AffiliateData.length; i++){
          if(allowedaffiliates.indexOf(AffiliateData[i]["AffiliateID"].toString()) > -1){
            allowedFamilies.push(AffiliateData[i].DTSPID.toString());
          }
        }
      }
      catch(o){}
    }
    let optsFamily = [];
    let FirstFamilyID = true;
    for(var i = 0; i < FamilyData.length; i++){
      if(allowedFamilies.length > 0 && allowedFamilies.indexOf(FamilyData[i]["iATSPGroupID"].toString()) < 0){
        continue;
      }
      if(FirstFamilyID == true){FirstFamilyID = false; initialFamilyGroupSelected.push(FamilyData[i]["iATSPGroupID"].toString()); }
      optsFamily.push({"name":FamilyData[i]["vATSPGroupName"], "id":FamilyData[i]["iATSPGroupID"]})
    }
    SetFamilyGroupsMultiSelect({ ...FamilyGroupsSingleSelect, ...{options: optsFamily}});
    FilterAffiliatesBySelectedFamily(initialFamilyGroupSelected);
    let familyID = GetDefaultFamilyID();
    clusterComboData.current = [];
    affChangeFlagRef.current = "";
    affChangeFlagRef.current = props.selectedAffiliates;
      showDropDownOptions({Given:"COMPANY", Value:familyID});
  },[]);

  useEffect(() => {
    if(typeof props.ToolBoxStateChange === "function"){
      props.ToolBoxStateChange(ToolboxValues);
    }
  }, [ToolboxValues]);

  useEffect(() => {
    try{
      let sections = props.selectedAffiliates.split(',');
      let firstAff = "";
      if(sections.length > 0)
      {
        firstAff = parseInt(sections[0]);
      }
      else
      {
        firstAff = (props.selectedAffiliates && props.selectedAffiliates !== ""?parseInt(props.selectedAffiliates):0);
      }
      if(firstAff > 0)
      {
        transitTypeRef.current = AffiliateData.filter((item,index) => {
          try{
            return parseInt(item.AffiliateID) === firstAff;
          }
          catch(err){console.log(err);}
        });
      }
      
    }
    catch(err){console.log(err);}
  }, [props.selectedAffiliates]);

  useEffect(() => {
    if(typeof props.ToolBoxStateChange === "function"){
      // console.log(ToolboxValues.AffiliatesList);
      if(affChangeFlagRef.current !== String(props.selectedAffiliates))
      {
        let affSelection = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0]:ToolboxValues.AffiliatesList);
        clusterComboData.current = [];
        // console.log("toolbox", affSelection, ToolboxValues.AffiliatesList, props.selectedAffiliates);
        showDropDownOptions({Given:"AFFILIATE", Value:affSelection});  
      }
    }
  }, [ToolboxValues.AffiliatesList,ToolboxValues.Date]);

  useEffect(() => {
    if(props.nullifyActivated)
    {
      props.setNullifyActivated(false);
      let affSelection = (ToolboxValues.AffiliatesList.includes(",") ? ToolboxValues.AffiliatesList.split(",")[0]:ToolboxValues.AffiliatesList);
      showDropDownOptions({Given:"AFFILIATE", Value:affSelection});
      // setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, options: [], selectedValues: "" });
    }
  }, [props.nullifyActivated]);

  function StatusFilterSelectCallback(selectedvals) {
    SetToolboxValues({...ToolboxValues,...{StatusList:selectedvals.join(",")}});
  }
  function GroupingSelectCallback(selectedvals) {
    SetToolboxValues({...ToolboxValues,...{Grouping:selectedvals.join(",")}});
  }
  function AttributesSelectCallback(selectedvals) {
      let all_attributes_value = document.getElementsByClassName('DispatchGridAttributesSelect')[0].innerText;
      if (all_attributes_value === 'All Attributes'){
        SetToolboxValues({...ToolboxValues, ...{AttrList: ""}});
      }
      else {
        SetToolboxValues({...ToolboxValues, ...{AttrList: selectedvals.join(",")}});
      }
  }
  function FSSelectCallback(selectedvals){
    SetToolboxValues({...ToolboxValues,...{FSList:selectedvals.join(",")}});
  }
  function FamilyGroupsSelectCallback(selectedfamily) {
    FilterAffiliatesBySelectedFamily(selectedfamily);
  }
  function RequestedDateChange(newdate) {
    PersistStorage.save("DispatchToolBarDate", newdate, 360, false);
    SetToolboxValues({...ToolboxValues,...{Date:newdate}});
  }
  function RequestTotalHours(newval) {
    SetToolboxValues({...ToolboxValues,...{TotalHours: parseInt(newval) }});
  }
  function FilterAffiliatesBySelectedFamily(selectedvals){
    let optsAffiliates = [];
    let initialAffiliatesListSelected = [];
    let allowedaffiliates = loginData.UserAffiliateList.split(',');
    let allowedValidAffiliates = [];
    if(allowedaffiliates.length>0){
      try{
        for(var i = 0; i < AffiliateData.length; i++){
          if(allowedaffiliates.indexOf(AffiliateData[i]["AffiliateID"].toString()) > -1){
            allowedValidAffiliates.push(AffiliateData[i]["AffiliateID"].toString());
          }
        }
      }
      catch(o){}
    }
    for(var i = 0; i < AffiliateData.length; i++){
      if(allowedValidAffiliates.length>0 && allowedValidAffiliates.indexOf(AffiliateData[i]["AffiliateID"].toString()) < 0){
        continue;
      }
      if(selectedvals.indexOf(AffiliateData[i].DTSPID.toString()) > -1){
        initialAffiliatesListSelected.push(AffiliateData[i]["AffiliateID"].toString());
        optsAffiliates.push({"name":AffiliateData[i]["AffiliateCompany"], "id":AffiliateData[i]["AffiliateID"]});
      }
    }
    SetToolboxValues({...ToolboxValues,...{AffiliatesList:initialAffiliatesListSelected.join(",")}});
    SetAffiliatesFilterMultiSelect({ ...AffiliatesFilterMultiSelect, ...{options: optsAffiliates}});
    FilterFundingSourcesBySelectedAffiliates(initialAffiliatesListSelected);
    FilterAttributesBySelectedAffiliates(initialAffiliatesListSelected);
  }
  function FilterFundingSourcesBySelectedAffiliates(selectedAffiliates){
    let optsFS = [];
    for(const key in FundingSourceData)
    {
      if (FundingSourceData.hasOwnProperty(key) && selectedAffiliates.indexOf(key.toString()) > -1) {
        const value = FundingSourceData[key];
        try {
          const FundingSourceDataJSON = JSON.parse(value);
          for(var i = 0; i < FundingSourceDataJSON.length; i++){
             optsFS.push({"name":FundingSourceDataJSON[i]["AccountID"] + " (" + FundingSourceDataJSON[i].AffiliateAbbrevation + ")", "id":(FundingSourceDataJSON[i]["FID"] + "-" + FundingSourceDataJSON[i]["iFSATSPID"])});
          }
        } catch (error) {
        }
      }
    }
    SetFundingSourceFilterMultiSelect({ ...FundingSourceFilterMultiSelect, ...{options: optsFS}});
  }
  function FilterAttributesBySelectedAffiliates(selectedAffiliates){
    let optsAttr = AttributeData.filter(function(currentValue){
      return selectedAffiliates.indexOf(currentValue.iAttrATSPID.toString()) > -1? true: false;
    }).map(function(currentValue, index, origarray) {
        return {"name":currentValue.DisplayTitle, "id":currentValue.ID};
    });
    SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: optsAttr}});
  }

  function FilterOptionsAccordingToSelectedAffiliates(selectedAffiliatesInIntForm){
    let selectedAffiliates = selectedAffiliatesInIntForm.map(function(currentValue) {return currentValue.toString(); });
    SetToolboxValues({...ToolboxValues,...{AffiliatesList:selectedAffiliates.join(",")}});
        mapBtnRef.current.textContent = "Map";
        mapBtnRef.current.title = "Map View";
        props.selectedTripInfoToRefreshGrid.current= null
        props.DropDownRouteValue.current= null
        props.setDetailDataFunc([])
        props.handleMapHeight(100);
        props.handleMapMode(false);


    FilterFundingSourcesBySelectedAffiliates(selectedAffiliates);
    FilterAttributesBySelectedAffiliates(selectedAffiliates);
  }

    const dropdownpadding = {
      paddingLeft: '5px'
    };
    
    useEffect(() => {
      setSelectedRouteOrCluster(props.selectedRoute);
      setrouteFilterMultiSelect({ ...clusterFilterMultiSelect, ...{ selectedValues: GetClusterSelectObjectBy(props.selectedRoute) } });
    },[props.selectedRoute]);

    return ( 
      <>
      <Navbar ref={navBarRef} className="bg-body-tertiary justify-content-between DispatchToolbarNav" style={{height:'60px'}}>
        <Form className='form-inline'>
          <InputGroup>
            {/* <InputGroup.Text id="basic-addon1">@</InputGroup.Text> */}
            <MultiSelectDropdown options={StatusFilterMultiSelect} style={dropdownpadding} SelectionChangeCallback={StatusFilterSelectCallback} /> 
            <MultiSelectDropdown options={GroupingMultiSelect} style={dropdownpadding} SelectionChangeCallback={GroupingSelectCallback} /> 
            <MultiSelectDropdown options={AttributesFilterMultiSelect} style={dropdownpadding} SelectionChangeCallback={AttributesSelectCallback} />  
            <MultiSelectDropdown options={FamilyGroupsSingleSelect} singleselect="true" style={dropdownpadding} SelectionChangeCallback={FamilyGroupsSelectCallback} />  
            <MultiSelectDropdown options={AffiliatesFilterMultiSelect} singleselect="true" style={dropdownpadding} SelectionChangeCallback={FilterOptionsAccordingToSelectedAffiliates} />  
            <MultiSelectDropdown options={FundingSourceFilterMultiSelect} style={dropdownpadding} SelectionChangeCallback={FSSelectCallback} /> 
            <DateTimePicker options={RequestDateOptions} SelectionChangeCallback={RequestedDateChange}></DateTimePicker>
            <NumericControl options={RequestTotalHoursOptions} SelectionChangeCallback={RequestTotalHours}></NumericControl>
            {/* <Button variant='light' onClick={handleInvokeCancelTrip} ><img src={cancel_icon} className='cancel_icon_width' alt="cancel_icon" /></Button> */}
            <Button variant='outline-dark' id={props.options.GridName+'_mapViewBtn'} type='button' title='Map View' className='rounded mx-1 px-2 z-0' onClick={handleMapView} ref={mapBtnRef}>Map</Button>
            {showRouteDropDown ?
              <div title='Select Route' className='text-nowrap SelectRouteDiv' onClick={handleRouteDropDownClick}>
                <MultiSelectDropdown  selectedValues = {SelectedRouteOrCluster} options={clusterFilterMultiSelect} showCheckbox={false} className="mx-1" SelectionChangeCallback={RouteSelectCallback} />
              </div>
              
            :""}
            {showRouteDropDown?
              <div className='p-1 border rounded mx-1'>
                <p className='m-0 d-inline-flex fw-bold user-select-none' style={{fontSize:"small", minWidth:"135px"}}>Show Completed</p>
                <input type={"checkbox"} style={{cursor:"pointer"}} title="Show Completed Trips" className='mx-1 d-inline-flex' onClick={handleCheckCompleted}/>
              </div>  
              :""
            }
            {/* <Button variant='light' onClick={handleInvokeActivateTrip} ><img src={activatetrip_icon} className='activate_icon_width' alt="activate_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeTripActions} ><img src={tripactions_icon} title='Trip Actions' className='tripaction_icon_width' alt="tripactions_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeDriverActions} ><img src={driveraction_icon} title='Driver Actions' className='driveractions_icon_width' alt="driveractions_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeVehicleTracking} ><img src={vehicletracking_icon} title='Send Vehicle Tracking Message' className='vehicletrack_icon_width' alt="vehicletracking_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeUpdateCallback} ><img src={callback_icon} title='Update Customer Callback Counter' className='callback_icon_width' alt="callback_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeGroupingActions} ><img src={groupingaction_icon} title='Group/UnGroup Actions' className='groupingactions_icon_width' alt="groupingactions_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeClusteringActions} ><img src={cluster_icon} title='Build Cluster' className='cluster_icon_width' alt="cluster_icon" /></Button> */}
            {/* <Button variant='light' onClick={handleInvokeTripHistoryActions} ><img src={history_icon} title='Trip History' className='historyactions_icon_width' alt="historyactions_icon" /></Button> */}
            <p className='m-0 mx-1 mt-1 user-select-none d-none'>R:{props.TimeTakenByLastGridCall}&nbsp;</p>
            <p className='m-0 mt-1 user-select-none d-none'>N:{props.NetworkTimeTakenByLastGridCall}</p>
            {(props.options.groupByColumns && props.options.groupByColumns.length > 0) ? <select onChange={handleSetGroupingHeader} title={"Group Table Rows By Column Name"} className='rounded border text-center py-2'>
              {props.options.groupByColumns.map((item, index)=>(
                <option key={index} value={item}>{item}</option>
              ))}
            </select>:""}
          </InputGroup>
        </Form>
      </Navbar>
      {menuSideBarToggle ? "":<Button type='button' variant='light' style={{right:'0.3%', top:'6%'}} className='border-0 rounded mx-2 px-1 position-absolute' onClick={handleInvokeSidebarToggle} title="Actions Menu Sidebar"><Icon icon="bx:menu"  className='w-100'  style={{color:"gray", height:"30px", cursor:"pointer", display:"block", zIndex:"999"}}/></Button>}
      {menuSideBarToggle ? <MenuSideBar SetSidebarStatus={props.setSideBarStatus} options={props.options} navbarTracker={navBarRef.current} btnFuncs={(transitTypeRef.current.length > 0 && parseInt(transitTypeRef.current[0].iTransType) === 2) ? [
        {btnName: "input", btnFunc: handleUserInput, icon:"NA", title: ""},
        {btnName: "Standing Routes", btnFunc: handleStandingRouteActions, icon:"table", title: "Manage/Save Standing Routes"},
        {btnName: "RBSProcess", btnFunc: handleInvokeRBSProcessActions, icon:"dice-1", title: "RBSProcess"},
        {btnName: "Cancel", btnFunc: handleInvokeCancelTrip, icon: "task-x", title: "Cancel Trip", tag:"tag_CancelRequest"}, 
        {btnName: "Activate", btnFunc: handleInvokeActivateTrip, icon:"calendar-check", title: "Activate Trip"}, 
        {btnName: "Trip Reservation", btnFunc: handleInvokeCallAgent, icon:"book-bookmark", title: "Reserve a trip"},
        {btnName: "Agile Dispatch", btnFunc: handleInvokeAgileDispatch, icon:"vector", title: "Agile Dispatch", tag:"tag_DispatchActions"}, 
        {btnName: "Dispatch Actions", btnFunc: handleInvokeTripActions, icon:"cog", title: "Dispatch Actions"}, 
        {btnName: "Driver Controls", btnFunc: handleInvokeDriverActions, icon:"taxi", title: "Driver & Admin Actions"},
        {btnName: "Vehicle Tracking", btnFunc: handleInvokeVehicleTracking, icon:"message-detail", title: "Send Vehicle Tracking Message"},
        {btnName: "Callback Counter", btnFunc: handleInvokeUpdateCallback, icon:"phone-call", title: "Update Customer Callback Counter"},
        {btnName: "Grouping Actions", btnFunc: handleInvokeGroupingActions, icon:"dice-5", title: "Group/UnGroup Actions"},
        {btnName: "Clustering Actions", btnFunc: handleInvokeClusteringActions, icon:"network-chart", title: "Cluster/Uncluster Trips"},
        {btnName: "Trip History", btnFunc: handleInvokeTripHistoryActions, icon:"history", title: "Trip History"}, 
        {btnName: "Broker Actions", btnFunc: handleBrokerActions, icon:"group", title: "Broker Actions"}, 
        {btnName: "Manifest Actions", btnFunc: handleInvokeBuildManifestActions, icon:"trip", title: "Manifest Action"},
        {btnName: "Route Restrictions", btnFunc: handleInvokeShowRoutes, icon:"shield", title: "Route Restrictions"},
        {btnName: "Trip Information", btnFunc: handleTripInformation, icon:"info-circle", title: "Trip Information"},
        {btnName: "MT Diagnostic", btnFunc: handleMTDiagnostic, icon:"info-circle", title: "MT Diagnostic"},
        {btnName: "Sign Out", btnFunc: handleLogout, icon:"log-out", title: "Sign Out"}]
        :[
          {btnName: "input", btnFunc: handleUserInput, icon:"NA", title: ""},
          {btnName: "Standing Routes", btnFunc: handleStandingRouteActions, icon:"table", title: "Manage/Save Standing Routes"},
          {btnName: "RBSProcess", btnFunc: handleInvokeRBSProcessActions, icon:"dice-1", title: "RBSProcess"},
          {btnName: "Cancel", btnFunc: handleInvokeCancelTrip, icon: "task-x", title: "Cancel Trip", tag:"tag_CancelRequest"}, 
          {btnName: "Activate", btnFunc: handleInvokeActivateTrip, icon:"calendar-check", title: "Activate Trip"}, 
          {btnName: "Trip Reservation", btnFunc: handleInvokeCallAgent, icon:"book-bookmark", title: "Reserve a trip"},
          {btnName: "Agile Dispatch", btnFunc: handleInvokeAgileDispatch, icon:"vector", title: "Agile Dispatch", tag:"tag_DispatchActions"}, 
          {btnName: "Dispatch Actions", btnFunc: handleInvokeTripActions, icon:"cog", title: "Dispatch Actions"}, 
          {btnName: "Driver Controls", btnFunc: handleInvokeDriverActions, icon:"taxi", title: "Driver & Admin Actions"},
          {btnName: "Vehicle Tracking", btnFunc: handleInvokeVehicleTracking, icon:"message-detail", title: "Send Vehicle Tracking Message"},
          {btnName: "Callback Counter", btnFunc: handleInvokeUpdateCallback, icon:"phone-call", title: "Update Customer Callback Counter"},
          {btnName: "Grouping Actions", btnFunc: handleInvokeGroupingActions, icon:"dice-5", title: "Group/UnGroup Actions"},
          {btnName: "Clustering Actions", btnFunc: handleInvokeClusteringActions, icon:"network-chart", title: "Cluster/Uncluster Trips"},
          {btnName: "Trip History", btnFunc: handleInvokeTripHistoryActions, icon:"history", title: "Trip History"}, 
          {btnName: "Broker Actions", btnFunc: handleBrokerActions, icon:"group", title: "Broker Actions"}, 
          {btnName: "Manifest Actions", btnFunc: handleInvokeBuildManifestActions, icon:"trip", title: "Manifest Action"},
          {btnName: "Route Restrictions", btnFunc: handleInvokeShowRoutes, icon:"shield", title: "Route Restrictions"},
          {btnName: "Trip Information", btnFunc: handleTripInformation, icon:"info-circle", title: "Trip Information"}, 
          {btnName: "Sign Out", btnFunc: handleLogout, icon:"log-out", title: "Sign Out"}]
        } 
          setMenuSidebarToggle={setMenuSidebar}/>
      : ""}
      {/* {btnName: "Trip Edit", btnFunc: handleInvokeEditTripCallAgent, icon:"edit", title: "Edit a trip"}, */}
      {invokeEditRouteSettings ? <EditRouteSettings affiliate={affiliateRef.current} data={editRouteSetDataRef.current} invokeEditSetting={invokeEditRouteSettings} setInvokeEditRouteSettings={setInvokeEditRouteSettings} SelectedDate = {ToolboxValues.Date} />: ""}
      {showDynamicModal ? 
        <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowDynamicModal(false)} show={showDynamicModal} animation={true}>
            <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none p-0 py-1 px-2' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            <Modal.Footer className='p-0 px-2 py-1'>
              {modalFooterHTML}
            </Modal.Footer>
        </Modal>
      : ""}
      </>
  );
};

export default DispatchMainToolbar;
